import { isObject } from "lodash";

export interface RequestInfo {
  body?: BodyInit | null;
  headers?: HeadersInit;
  method?: string;
  url: string;
}

interface ApiErrorParams {
  body?: unknown;
  errorDetails?: string | Record<string, any>;
  message: string;
  request?: RequestInfo;
  response?: Response;
  status: number;
  statusText: string;
}

export class ApiError extends Error {
  status: number;
  statusText: string;
  errorDetails?: string | Record<string, any>;
  body?: any;
  firstErrorDetail?: any;
  request?: RequestInfo;
  response?: Response;

  constructor({
    status,
    statusText,
    message,
    errorDetails,
    body,
    request,
    response,
  }: ApiErrorParams) {
    super(message);
    this.status = status;
    this.statusText = statusText;
    this.errorDetails = errorDetails;
    this.body = body;
    this.request = request;
    this.response = response;

    if (isObject(errorDetails)) {
      this.firstErrorDetail = Object.values(errorDetails)?.[0];
    }
  }
}

interface NotFoundErrorParams {
  message: string;
}

export class NotFoundError extends Error {
  status: number;

  constructor({ message }: NotFoundErrorParams) {
    super(message);
    this.status = 404;
  }
}
